import { uiSize } from '@utils'

interface Props {
  color?: string
}

function ChevronUpIcon({ color = 'var(--banky-black)' }: Props) {
  return (
    <svg width={uiSize(12)} height={uiSize(7)} viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11 6L6 0.999999L1 6' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

export default ChevronUpIcon
